<template>
  <div
    class="as-player"
    :class="{
      'as-player-end': flex === 'end',
      'as-player-sm': screenWidth < 370,
    }"
  >
    <div class="as-player-logo">
      <img :src="getImgUrlBySport('player', player.id)" />
    </div>
    <div class="as-player-content">
      <div
        v-if="!isInjuredSuspended"
        class="as-d-flex as-align-items-center as-gap-4"
        :class="{
          'as-justify-content-end': flex === 'end',
          'as-player-start': flex === 'start',
        }"
      >
        <div
          v-for="(incident, incidentKey) in player.incidents"
          :key="incidentKey"
          class="as-player-incident"
        >
          <component
            v-if="getIncidentIcon(player, incident, isSubstituted)"
            :is="getIncidentIcon(player, incident, isSubstituted)"
          />
          <span v-if="[1, 9].includes(incident.type)" class="as-time">{{ incident.time }}'</span>
        </div>
        <div
          v-if="player.rating !== '0.0'"
          class="as-player-rating"
          :style="{
            background: formatRateColor(parseFloat(player.rating)),
          }"
        >
          {{ player.rating }}
        </div>
      </div>
      <div class="as-player-shirt">
        <span v-if="isInjuredSuspended">{{ player.shirt_number ? player.shirt_number : "" }}-{{ player.name }}</span>
        <span v-else
          >{{ player.shirt_number ? player.shirt_number : "" }}-{{
            player.position
          }}.{{ player.name }}</span
        >
      </div>
      <div
        v-if="isInjuredSuspended"
        class="as-injured-suspended"
        :class="{
          'as-text-right': flex === 'end',
        }"
      >
        <IconHealthCare v-if="player.type === 1 && flex !== 'end'" />
        <IconRedCard v-if="player.type === 2 && flex !== 'end'" />
        <span :class="player.type === 1 ? 'as-injured' : 'as-suspended'">
          {{ player.type === 1 ? "Chấn thương" : "Treo giò" }}
        </span>
        <IconHealthCare v-if="player.type === 1 && flex === 'end'" />
        <IconRedCard v-if="player.type === 2 && flex === 'end'" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import type { IPlayer } from "~src/interfaces";
import { formatRateColor, getIncidentIcon } from "~src/helpers";
import IconHealthCare from "~src/components/icons/IconHealthCare.vue";
import IconRedCard from "~src/components/icons/IconRedCard.vue";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
const matchDetailStore = useMatchDetailStore();

interface IProps {
  player: IPlayer;
  flex: string;
  isInjuredSuspended: boolean;
  isSubstituted: boolean;
}

withDefaults(defineProps<IProps>(), {
  flex: "start",
  isInjuredSuspended: false,
  isSubstituted: false,
});

const screenWidth = computed(() => matchDetailStore.getScreenWidth);
</script>

<script lang="ts">
export default {};
</script>
